import { Bell, Key } from 'lucide-react';

import ChangePassword from '../../Auth/Login/ChangePassword';
import ResetMpin from '../../Auth/Login/components/ResetMpin';

import PushNotificationSettings from './PushNotificationSettings';

export const getUserSettingTabs = (isMpinSet, pushNotificationEnabled) => [
  {
    header: (
      <div className="flex tab-icon-section align-items-center gap-2">
        <Key className="w-1rem h-1rem text-yellow-600 fill-transparent" />
        <span>Password</span>
      </div>
    ),
    component: ChangePassword,
    isVisible: true,
  },
  {
    header: (
      <div className="flex tab-icon-section align-items-center gap-2">
        <Bell className="w-1rem h-1rem text-green-600 fill-transparent" />
        <span>Notifications</span>
      </div>
    ),

    component: PushNotificationSettings,
    isVisible: pushNotificationEnabled,
  },
  {
    header: (
      <div className="flex tab-icon-section align-items-center gap-2">
        <Key className="w-1rem h-1rem text-pink-600 fill-transparent" />
        <span>{isMpinSet === 'true' ? 'Reset Pin' : 'Pin Setup'}</span>
      </div>
    ),
    component: ResetMpin,
    isVisible: true,
  },
];
